import styled from '@emotion/styled';

import colors from 'resources/styles/colors';

export const SurveyPanel = styled.div`
  display: flex;
  justify-content: space-between;
`;

interface SurveyContainerProps {
  _hasbuttons: boolean;
}

export const SurveyContainer = styled.div<SurveyContainerProps>`
  flex-grow: 1;
  .sv-question__header {
    position: relative;
    h5.sv-title {
      max-width: ${({ _hasbuttons }) => (_hasbuttons ? 'calc(100% - 90px)' : '100%')};
      display: block;
      white-space: pre-wrap;
    }
    .question-buttons {
      position: absolute;
      width: 80px;
      bottom: 0;
      right:0;
    }
  }
  .sv-file__clean-btn {
    display: none;
  }
  .sv-page__description {
    color: ${colors.orange} !important;
    line-height: 22px;
    font-size: 22px;
    padding: 30px 0 32px 10px;
  }
  .sv-container-modern__title {
    padding-top: 40px;
  }
  .sv-description {
    white-space: pre-wrap;
    p {
      margin-bottom: 5px;
    }
    button.clamp-button {
      background: transparent;
      border: none;
      color: ${colors.green};
      font-size: 16px;
      padding: 0;
      text-decoration: underline;
    }
  }
  .sv-file__preview {
    display: none;
  }

  .sv-root-modern .sv-container-modern {
    color: black !important;
  }

  .sv-question--disabled {
    .sv-title-actions__title,
    .sv-string-viewer  {
      color: ${colors.darkGray};
    }
  }
`;

export const SubmitInfo = styled.div`
  margin: 1rem 5% 0 5%;
  font-weight: 600;
  font-size: 1.1rem;
  color: ${colors.darkGray};
`;

type SaveStatus = 'saved' | 'saving' | 'unsaved' | 'failed';

interface SaveStatusBarProps {
  status: SaveStatus;
}

const getStatusColor = (status: SaveStatus) => {
  switch (status) {
    case 'saved':
      return colors.green;
    case 'saving':
      return colors.orange;
    case 'unsaved':
      return colors.darkerGray;
    case 'failed':
      return colors.red;
    default:
      return colors.darkerGray;
  }
};

export const SaveStatusWrapper = styled.div`
  position: sticky;
  top: 1rem;
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
  margin-bottom: 1rem;
  z-index: 10;
`;

export const SaveStatusBar = styled.div<SaveStatusBarProps>`
  min-width: 260px;
  border: 1px solid ${colors.lightGray};
  border-radius: 6px;
  padding: 0.75rem 1rem;
  background: ${colors.white};
  box-shadow: 0 1px 3px ${colors.lightGray};
  color: ${colors.darkGray};

  .status-label {
    color: ${({ status }) => getStatusColor(status)};
    font-weight: 700;
    margin-bottom: 0.25rem;
  }

  .timestamp-label {
    font-size: 0.85rem;
    margin-bottom: 0.5rem;
  }
`;

export const RetryButton = styled.button`
  border: 1px solid ${colors.primaryColor};
  border-radius: 4px;
  background: ${colors.white};
  color: ${colors.primaryColor};
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.25rem 0.75rem;
`;
